<form class="step-form">
  <div class="grid-container">
    <div class="grid-x grid-padding-x formfield">
      <div class="cell">
        @for (field of formConfig.getFieldsFromGroup(steps.currentStep.name); track field) {
          <div formfield [invalidIfEmpty]="false" [form]="form" [formModel]="field"  [formConfig]="formConfig" step="stromcheck" class="formfield "></div>
        }
      </div>
    </div>
    <a [href]="headstageVersionButtonUrl" (click)="saveData()" [class.disabled]="!form.valid" class="button signal2 inline-arrow-right" target="_top">{{ 'stromcheck.kopfbuehne.submit' | translate }}</a>
  </div>
</form>
